
export function scrollAnywhereInit() {
    const scrollAnywhereLinks = document.querySelectorAll('a.js-scroll-anywhere');
    scrollAnywhereLinks.forEach(link => {
        link.addEventListener('click', evt => {
            let target;
            if (link.dataset.hash) {
                target = document.querySelector(`#${link.dataset.hash}`);
            } else {
                target = document.querySelector(link.getAttribute('href'));
            }
            if (!target) {
                return;
            }

            let targetScrollPosition = parseInt(target.offsetTop, 10);
            if (!targetScrollPosition) {
                targetScrollPosition = target.parentElement.offsetTop;
            }
            if (link.hasAttribute('data-offset')) {
                let offset = link.getAttribute('data-offset');
                targetScrollPosition = targetScrollPosition - parseInt(offset, 10);
            }

            evt.preventDefault();

            window.scroll(0, targetScrollPosition);
        });
    });
}